<template></template>

<script>
import { getwxUserInfo } from '@/api/common';

export default {
  data() {
    return {};
  },
  async created() {
    // 判断是否已经含有用户信息
    if (!this.$store.state.userInfo) {
      let code = this.getParam('code');
      // 判断当前url中是否含有code，有则进行用户信息获取
      if (code) {
        localStorage.setItem('code', code);
        let { appsecret } = window.sys;
        try {
          let wxInfoRes = await getwxUserInfo(code, appsecret);
          this.$store.commit('SET_USERINFO', wxInfoRes.data);
          localStorage.setItem('wxInfoRes', JSON.stringify(wxInfoRes.data));
          localStorage.setItem('openid', wxInfoRes.data.openid);
          this.$router.push({ path: './personalCenter' }); // 登录成功之后返回个人中心
        } catch (error) {
          console.log('error 22:>> ', error);
        }
      } else {
        console.log('没有code :>> ');
      }
    } else {
      console.log('已经获取用户信息 :>> ');
      this.$router.push({ path: './personalCenter' }); // 已经有病人信息，返回个人中心
    }
  },
  methods: {
    getParam(variable) {
      if (this.$route && this.$route.query && this.$route.query[variable]) {
        return this.$route.query[variable];
      }

      var queryList = [];
      if (window.location.search) {
        queryList.push(window.location.search.substring(1));
      }

      var hash = window.location.hash || '';
      var hashQueryIndex = hash.indexOf('?');
      if (hashQueryIndex > -1) {
        queryList.push(hash.substring(hashQueryIndex + 1));
      }

      for (var queryIndex = 0; queryIndex < queryList.length; queryIndex++) {
        var vars = queryList[queryIndex].split('&');
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair.slice(1).join('='));
          }
        }
      }
      return false;
    }
  }
};
</script>
<style lang="scss" scoped></style>
